import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.state = false
    this.el.addEventListener('click', () => {
      this.state = !this.state
      document.body.classList.toggle('has-menu', this.state)
    })
  }
}
